import angular from 'angular';
import { directive, factory } from './app';
import { OPEN } from '../../../common/const/access-level';
import { NO_CACHE } from './constants';

directive('recaptcha', [
  '$window',
  function($window) {
    return {
      restrict: 'E',
      scope: {
        siteKey: '@'
      },
      link: function(scope, element, attrs) {
        scope.$watch('siteKey', function(val) {
          if (!val) {
            return;
          }

          injectRecaptcha(val);
        });

        function injectRecaptcha(val) {
          var recaptchaScript = document.createElement('script');
          recaptchaScript.setAttribute('src', 'https://www.recaptcha.net/recaptcha/api.js?render=' + val);
          element.append(angular.element(recaptchaScript));
        }
      }
    };
  }
]);

factory('grecaptcha', [
  '$window',
  '$timeout',
  'PublicStorageService',
  function($window, $timeout, PublicStorageService) {
    return async () => {
      let grecaptcha = $window.grecaptcha;

      if (grecaptcha) {
        return grecaptcha;
      }

      const { data: recaptchaConfig } = await PublicStorageService.getSiteKeys();

      async function injectRecaptcha(val) {
        var recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', 'https://www.recaptcha.net/recaptcha/api.js?render=' + val);
        let resolve, reject;
        const P = new Promise((res, rej) => {
          resolve = res;
          reject = rej;
        });
        recaptchaScript.onload = resolve;
        recaptchaScript.onerror = reject;
        document.head.append(recaptchaScript);

        return P;
      }

      // needed to allow recaptcha injection to complete
      await injectRecaptcha(recaptchaConfig.captchaPublicKey);

      grecaptcha = await $timeout(
        () => {
          return $window.grecaptcha;
        },
        500 //delay
      );

      return grecaptcha;
    };
  }
]);

factory('httpWithRecaptcha', [
  '$http',
  'grecaptcha',
  'PublicStorageService',
  'AccessLevel',
  function($http, grecaptcha, PublicStorageService, AccessLevel) {
    function httpWithCaptcha(action, { method, url, data, params = {}, responseType = undefined }) {
      let options = {
        method,
        url,
        headers: {
          ...NO_CACHE,
          'x-recaptcha-attempt': 1
        },
        params,
        data: method.toLowerCase() === 'get' ? undefined : data
      };
      if (method.toLowerCase() === 'get' && responseType) options = { ...options, responseType };

      return $http(options).then(
        async response => {
          console.trace('httpWithRecaptcha> First attempt');
          return response;
        },
        async () => {
          let resolve, reject;
          const P = new Promise((res, rej) => {
            resolve = res;
            reject = rej;
          });

          const R = await grecaptcha();
          const { data: recaptchaConfig } = await PublicStorageService.getSiteKeys();

          R.ready(function() {
            console.trace('httpWithRecaptcha> Second attempt');
            return R.execute(recaptchaConfig.captchaPublicKey, { action }).then(function(token) {
              $http({
                ...options,
                headers: {
                  ...options.headers,
                  'x-recaptcha-attempt': 2,
                  'x-recaptcha-token': token,
                  'x-recaptcha-action': action
                }
              }).then(resolve, reject);
            });
          });

          return P;
        }
      );
    }

    return (action, { method, url, data, params = {}, responseType = undefined }) => {
      if (AccessLevel.get() !== OPEN) {
        console.trace('Calling $http', { method, url, isLoggedIn: true });
        return $http({ method, url, data, params, responseType, headers: { ...NO_CACHE } });
      } else {
        console.trace('Calling httpWithCaptcha', { action, method, url, isLoggedIn: false });
        return httpWithCaptcha(action, { method, url, data, params, responseType });
      }
    };
  }
]);
